import { Table } from 'antd';
import moment from 'moment';
const { Column } = Table;
const TicketStatus = ({ data }) => {
    return (
        <Table
            dataSource={data}
            >
            <Column
                title='登録日'
                dataIndex='createdAt'
                render={(text) => {
                    return moment(text).format('YYYY/MM/DD');
                }}
            />
            <Column
                title='種類'
                dataIndex='type'
            />
            <Column
                title='詳細'
                dataIndex='body'
            />
            </Table>
    )
};
export default TicketStatus;